export const STEP_ADDRESS = {
  id: "address",
  name: "Adresse",
  url: "/rendez-vous-collecte/adresse",
};
export const STEP_PRODUCT_CHOICE = {
  id: "product",
  name: "Appareil",
  url: "/rendez-vous-collecte/choix-des-appareils",
};
export const STEP_DATE = { id: "date", name: "Créneaux", url: "/rendez-vous-collecte/choix-du-creneau" };

export const STEP_ACCOUNT = {
  id: "identification",
  name: "Informations",
  url: "/rendez-vous-collecte/informations",
};
export const STEP_CONFIRMATION = {
  id: "confirmation",
  name: "Confirmation",
  url: "/rendez-vous-collecte/confirmation-collecte",
};

export const STEPS = [STEP_ADDRESS.id, STEP_PRODUCT_CHOICE.id, STEP_DATE.id, STEP_ACCOUNT.id, STEP_CONFIRMATION.id];
export const STEPS_NAMES = [
  STEP_ADDRESS.name,
  STEP_PRODUCT_CHOICE.name,
  STEP_DATE.name,
  STEP_ACCOUNT.name,
  STEP_CONFIRMATION.name,
];

export const LOAD_FROM_STORAGE = "LOAD_FROM_STORAGE";

export const STEP_ADDRESS_URL = STEP_ADDRESS.url;
export const STEP_PRODUCT_CHOICE_URL = STEP_PRODUCT_CHOICE.url;
export const STEP_DATE_URL = STEP_DATE.url;
export const STEP_ACCOUNT_URL = STEP_ACCOUNT.url;
export const STEP_CONFIRMATION_URL = STEP_CONFIRMATION.url;

export const URL_TO_STATE = {
  adresse: 1,
  "choix-des-appareils": 2,
  "choix-du-creneau": 3,
  informations: 4,
  "confirmation-collecte": 5,
};

// events
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_TIMESLOT = "SET_TIMESLOT";
export const SET_PERSONNAL_INFORMATIONS = "SET_PERSONNAL_INFORMATIONS";
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_DELIVERY_ITEMS = "SET_DELIVERY_ITEMS";

export const STEP_INFORMATION = [
  {
    title: "Renseignez votre adresse",
    slug: "info-address",
  },
  {
    title: "Précisez-nous le type d’appareil",
    slug: "info-product",
  },
  {
    title: "Choisissez le jour",
    slug: "info-timeslot",
  },
];
export const FREEZER_NAME_TAG = "Réfrigérateur & congélateur";
export const NOT_A_PRODUCT_TYPE = "not a product";

export const MURFY_BOUGHT = "murfyBought";
export const MURFY_REPAIRED = "murfyRepaired";
export const IS_BROKEN = "isBroken";

export const MURFY_BOUGHT_ANSWERS = [
  { index: 0, question: MURFY_BOUGHT, text: "Oui", value: true },
  { index: 1, question: MURFY_BOUGHT, text: "Non", value: false },
];

export const MURFY_REPAIRED_ANSWERS = [
  { index: 0, question: MURFY_REPAIRED, text: "Oui", value: true },
  { index: 1, question: MURFY_REPAIRED, text: "Non", value: false },
];

export const MURFY_IS_BROKEN_ANSWERS = [
  { index: 0, question: IS_BROKEN, text: "Oui", value: false },
  { index: 1, question: IS_BROKEN, text: "Non", value: true },
];
